import { render, staticRenderFns } from "./InjuryTypeChangeActivationType.vue?vue&type=template&id=505612bb&"
import script from "./InjuryTypeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./InjuryTypeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports